import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectPermissionsForUser } from '@authorisation/selectors';
import { determineSourceTypeForNewContent } from '@utils';
import { useTranslation } from 'react-i18next';
import { OPEN_CONTENT, OPEN_LINK } from '@constants';
import { createContentMessage } from '@redux/contentMessages/actions';
import { selectContentMessagesCreating } from '@redux/contentMessages/selectors';
import { DOCUMENT, VIDEO } from '@utils/contentTypes';
import MessageWizard from './MessageWizard';

function getPayloadOptionsData(content) {
  switch (content.action) {
    case OPEN_CONTENT:
      return content.contentData;
    case OPEN_LINK:
      return content.websiteLink;
    default:
      return null;
  }
}

export default ({ type, messageTranslationKey, match: { path } }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const permissions = useSelector(selectPermissionsForUser);

  const onCompleted = useCallback(
    messageData => {
      const { details, content } = messageData;

      const newMessage = {
        name: details.name,
        published: details.status === 'publish' ? true : false,
        language: details.language,
        body: content.content,
        source: determineSourceTypeForNewContent(permissions),
        created: new Date().toISOString(),
        payload: {
          action: content.action,
          data: getPayloadOptionsData(content),
        },
        metadata: {
          type,
        },
      };

      if (
        newMessage.payload.data?.metadata &&
        [DOCUMENT, VIDEO].includes(newMessage.payload.data.metadata.type)
      ) {
        const {
          id,
          latest_version,
          metadata: { language, tags, type },
          name,
          owner_id,
          product_id,
          slug,
          token,
        } = newMessage.payload.data;

        newMessage.payload.data = {
          id,
          latest_version: { name: latest_version.name, description: latest_version.description },
          metadata: { language, tags, type },
          name,
          owner_id,
          product_id,
          slug,
          token,
        };
      }

      dispatch(createContentMessage(newMessage, type, messageTranslationKey, path));
    },
    [dispatch, messageTranslationKey, type, path, permissions],
  );

  const creating = useSelector(selectContentMessagesCreating);

  return (
    <MessageWizard
      title={t(`${messageTranslationKey}:NewContentMessageWizard.title`)}
      exitMessage={t(`${messageTranslationKey}:NewContentMessageWizard.exitConfirmation`)}
      type={type}
      onCompleted={onCompleted}
      loading={false}
      submitting={creating}
      messageTranslationKey={messageTranslationKey}
    />
  );
};
